<app-page-header [heading]="'Damage Products List'" [icon]="'fa-warning'" style="height:100px;"></app-page-header>
<div class="page-panel">
  <div class="row mb-2">
    <div class="col-lg-8 d-flex justify-content-end align-middle">
      <a class="btn  btn-success btn-sm ng-star-inserted" routerLink="/purchase/add-damage"
         title="Add damage details">&nbsp;<i
        class="fa fa-plus text-white"></i>&nbsp;</a>&nbsp;&nbsp;
    </div>
    <div class="col-lg-4">
      <div class="input-group ">
        <input (keydown)="keyDownFunction($event)" [(ngModel)]="damage.search_damage" class="form-control"
               id="typeahead-http"
               name="search_text" placeholder="Supplier name ..." style="height:31px"
               type="text">
        <div class="input-group-append">
          <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
            <i *ngIf="damage.search_damage != ''" class="fa fa-close"></i>
            <i *ngIf="damage.search_damage == ''" class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="">
    <table class="table  table-bordered">
      <thead>
      <tr class="text-center">
        <th width="2%">Sl</th>
        <th>Invoice Number</th>
        <th>Supplier</th>
        <th width="10%">Date</th>
        <th width="20%">Item</th>
        <th width="7%">Qty</th>
        <th width="7%">Rate</th>
        <th>Reason</th>
        <th colspan="2">Action</th>
      </tr>
      <tr *ngIf="(damage_data | json) == '[]'">
        <td class="text-center" colspan="13">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let data of damage_data;let j=index">
        <tr *ngFor="let item of data.ITEM;let i=index">
          <ng-container *ngIf="i == 0">
            <td [attr.rowspan]="data.ITEM.length" class="text-center">{{ j + 1 }}</td>
            <td [attr.rowspan]="data.ITEM.length"> {{ data.INVOICE_NUMBER }}</td>
            <td [attr.rowspan]="data.ITEM.length"> {{ data.VENDOR_NAME }}</td>
          </ng-container>
          <td class="text-center"> {{ item.CREATE_DATE }}</td>
          <td> {{ item.TRADE_NAME }}</td>
          <td class="text-center"> {{ item.DAMAGE_QUANTITY }}</td>
          <td class="text-right"> {{ item.DAMAGE_RATE }}</td>
          <td> {{ item.DAMAGE_DESCRIPTION }}</td>
          <ng-container *ngIf="i == 0">
            <td [attr.rowspan]="data.ITEM.length">
              <a *ngIf="user_rights.EDIT == '1'" alt="Edit" class="btn btn-xs btn-margin btn-primary"
                 routerLink="/purchase/add-damage/edit/{{data.DAMAGE_PURCHASE_ID}}" style="font-size:10px" title="Edit"><i
                class="fa fa-edit"></i></a>
            </td>
          </ng-container>
          <td class="text-center">
            <button (click)="deleteDamage(item);" alt="Delete" class=" btn btn-xs btn-margin btn-danger"
                    style="font-size:10px"
                    title="Delete"><i class="fa fa-trash"></i></button>
          </td>


        </tr>
      </ng-container>
      </tbody>
    </table>
    <app-pagination (pageChange)="getDamageList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
  </div>
</div>



